import { render } from "./grid-legend.vue?vue&type=template&id=5acb0f2c&ts=true"
import script from "./grid-legend.vue?vue&type=script&lang=ts"
export * from "./grid-legend.vue?vue&type=script&lang=ts"

import "./grid-legend.vue?vue&type=style&index=0&id=5acb0f2c&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__